export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12202.cc92ee1f.jpg";